// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"b5277055","348":"9c656fc4","422":"05a88dbc","478":"b872f923"}[chunkId] + ".chunk.js";
};